import { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { faqs } from '@/mocks/events';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <>
      <Seo
        title="常见问题（FAQ）- 69爆料｜实锤、辟谣反锤与投稿说明"
        description="69爆料常见问题：什么是实锤与石锤、与普通吃瓜号的区别、辟谣反锤如何运作、素材如何辨别剪辑、如何投稿补充证据等。"
        keywords="69爆料FAQ,实锤是什么,辟谣反锤,证据检索,如何投稿,69爆料问答"
        canonicalPath="/faq"
        jsonLd={faqJsonLd}
      />

      <section className="bg-foreground-950 text-background-50">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-10 md:py-14">
          <nav className="text-xs text-background-300 flex items-center gap-1.5" aria-label="面包屑">
            <Link to="/" className="hover:text-secondary-300 transition-colors">档案首页</Link>
            <i className="ri-arrow-right-s-line"></i><span>常见问题</span>
          </nav>
          <div className="mt-5 max-w-2xl">
            <h1 className="font-display font-black text-3xl md:text-5xl">常见问题</h1>
            <p className="mt-3 text-background-200 text-sm md:text-lg leading-relaxed">
              关于「实锤」「石锤」「辟谣反锤」和投稿规则，你关心的问题都在这里。没找到答案？欢迎来稿提问。
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center gap-4 justify-between px-4 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                >
                  <span className="inline-flex items-center gap-3">
                    <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold shrink-0 ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-600'}`}>
                      Q{i + 1}
                    </span>
                    <span className="font-display font-bold text-foreground-950 text-sm md:text-lg">{f.q}</span>
                  </span>
                  <i className={`ri-${isOpen ? 'arrow-up-s' : 'arrow-down-s'}-line text-primary-600 text-2xl shrink-0`}></i>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-6 pb-5 md:pl-[3.8rem]">
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <aside className="lg:col-span-4 space-y-6">
          <div className="bg-background-100/70 border border-background-200 rounded-lg p-6">
            <h2 className="font-display font-bold text-foreground-950 text-lg flex items-center gap-2">
              <i className="ri-question-answer-line text-primary-600"></i>还没解决你的疑问？
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              如果你在检索证据、判断素材真实性或投稿时遇到问题，可以把你的疑问发给我们，我们会补充到问答库中。
            </p>
            <Link
              to="/about#contact"
              className="mt-4 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm rounded-full px-5 py-2.5 transition-colors"
            >
              <i className="ri-mail-send-line"></i>联系我们
            </Link>
          </div>
          <div className="bg-background-100/70 border border-background-200 rounded-lg p-6">
            <h2 className="font-display font-bold text-foreground-950 text-lg flex items-center gap-2">
              <i className="ri-folder-open-line text-accent-600"></i>相关页面
            </h2>
            <ul className="mt-3 space-y-2.5 text-sm">
              <li><Link to="/archive" className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-600 transition-colors"><i className="ri-database-2-line text-foreground-400"></i>实锤证据库</Link></li>
              <li><Link to="/archive?view=debunk" className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-600 transition-colors"><i className="ri-flag-2-line text-foreground-400"></i>辟谣反锤专区</Link></li>
              <li><Link to="/about#principles" className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-600 transition-colors"><i className="ri-shield-check-line text-foreground-400"></i>我们的内容原则</Link></li>
              <li><Link to="/about#contact" className="inline-flex items-center gap-2 text-foreground-700 hover:text-primary-600 transition-colors"><i className="ri-megaphone-line text-foreground-400"></i>投稿与线索</Link></li>
            </ul>
          </div>
        </aside>
      </section>
    </>
  );
}